module.exports = {
  "tableHorizontalPadding": "24px",
  "tableCellHorizontalPadding": "45px",
  "checkboxWidth": "20px",
  "filterBaseHorizontalPadding": "12px",
  "maxDepth, @depth": "1) when (@depth =< @max-depth) {\r\n        &.depth-@{depth} {\r\n            padding-left:@filter-base-horizontal-padding + @common-horizontal-padding * @depth",
  "iconWidth": "16px"
};
